import isStrongPassword from "validator/lib/isStrongPassword.js";

const passwordFormat = { minLength: 5, minUppercase: 1, minNumbers: 1, minSymbols: 1, minLowercase: 0 };

export default {

  required: {
    message : "Please enter password",
    fn      : (input)=> input.length,
  },

  format: {
    message : "Password must consist of at least 5 characters, 1 upper case letter, 1 number and 1 symbol.",
    fn      : (input)=> isStrongPassword(input, passwordFormat),
  },

  match: {
    message : "Passwords do not match",
    fn      : (input, opts)=> input == opts.match,
  }
}
